module.exports = __webpack_public_path__ + "static/media/coollogo_com-1173231.65cf690c.png";